import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/es6.string.iterator';
import 'core-js/modules/es6.array.from';
import 'core-js/modules/es6.function.name';
import 'core-js/modules/es6.regexp.to-string';
import 'core-js/modules/es6.reflect.construct';
import _classCallCheck from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js';
import _createClass from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js';
import _inherits from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js';
import _possibleConstructorReturn from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js';
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== 'undefined' && o[Symbol.iterator] || o['@@iterator'];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') {
            if (it)
                o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length)
                        return { done: true };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null)
                    it.return();
            } finally {
                if (didErr)
                    throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/* global window */
/**
 * @module ckfinder/ckfindercommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * The CKFinder command. It is used by the {@link module:ckfinder/ckfinderediting~CKFinderEditing ckfinder editng feature}
 * to open a CKFinder file browser to insert an image or a link to a file into content.
 *
 *		editor.execute( 'ckfinder' );
 *
 * @extends module:core/command~Command
 */
var CKFinderCommand = /*#__PURE__*/
function (_Command) {
    _inherits(CKFinderCommand, _Command);
    var _super = _createSuper(CKFinderCommand);
    /**
   * @inheritDoc
   */
    function CKFinderCommand(editor) {
        var _this;
        _classCallCheck(this, CKFinderCommand);
        _this = _super.call(this, editor);
        // Remove default document listener to lower its priority.
        _this.stopListening(_this.editor.model.document, 'change');
        // Lower this command listener priority to be sure that refresh() will be called after link & image refresh.
        _this.listenTo(_this.editor.model.document, 'change', function () {
            return _this.refresh();
        }, { priority: 'low' });
        return _this;
    }
    /**
   * @inheritDoc
   */
    _createClass(CKFinderCommand, [
        {
            key: 'refresh',
            value: function refresh() {
                var imageCommand = this.editor.commands.get('imageUpload');
                var linkCommand = this.editor.commands.get('link');
                // The CKFinder command is enabled when one of image or link command is enabled.
                this.isEnabled = imageCommand && linkCommand && (imageCommand.isEnabled || linkCommand.isEnabled);
            }    /**
     * @inheritDoc
     */
        },
        {
            key: 'execute',
            value: function execute() {
                var editor = this.editor;
                var openerMethod = this.editor.config.get('ckfinder.openerMethod') || 'modal';
                if (openerMethod != 'popup' && openerMethod != 'modal') {
                    throw new CKEditorError('ckfinder-unknown-openerMethod: The openerMethod config option must by "popup" or "modal".', editor);
                }
                var options = this.editor.config.get('ckfinder.options') || {};
                options.chooseFiles = true;
                // Cache the user-defined onInit method
                var originalOnInit = options.onInit;
                // Pass the lang code to the CKFinder if not defined by user.
                if (!options.language) {
                    options.language = editor.locale.uiLanguage;
                }
                // The onInit method allows to extend CKFinder's behavior. It is used to attach event listeners to file choosing related events.
                options.onInit = function (finder) {
                    // Call original options.onInit if it was defined by user.
                    if (originalOnInit) {
                        originalOnInit(finder);
                    }
                    finder.on('files:choose', function (evt) {
                        var files = evt.data.files.toArray();
                        // Insert links
                        var links = files.filter(function (file) {
                            return !file.isImage();
                        });
                        var images = files.filter(function (file) {
                            return file.isImage();
                        });
                        var _iterator = _createForOfIteratorHelper(links), _step;
                        try {
                            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                var linkFile = _step.value;
                                editor.execute('link', linkFile.getUrl());
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally {
                            _iterator.f();
                        }
                        var imagesUrls = [];
                        var _iterator2 = _createForOfIteratorHelper(images), _step2;
                        try {
                            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                                var image = _step2.value;
                                var url = image.getUrl();
                                imagesUrls.push(url ? url : finder.request('file:getProxyUrl', { file: image }));
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally {
                            _iterator2.f();
                        }
                        if (imagesUrls.length) {
                            insertImages(editor, imagesUrls);
                        }
                    });
                    finder.on('file:choose:resizedImage', function (evt) {
                        var resizedUrl = evt.data.resizedUrl;
                        if (!resizedUrl) {
                            var notification = editor.plugins.get('Notification');
                            var t = editor.locale.t;
                            notification.showWarning(t('Could not obtain resized image URL.'), {
                                title: t('Selecting resized image failed'),
                                namespace: 'ckfinder'
                            });
                            return;
                        }
                        insertImages(editor, [resizedUrl]);
                    });
                };
                window.CKFinder[openerMethod](options);
            }
        }
    ]);
    return CKFinderCommand;
}(Command);
export {
    CKFinderCommand as default
};
function insertImages(editor, urls) {
    var imageCommand = editor.commands.get('imageUpload');
    // Check if inserting an image is actually possible - it might be possible to only insert a link.
    if (!imageCommand.isEnabled) {
        var notification = editor.plugins.get('Notification');
        var t = editor.locale.t;
        notification.showWarning(t('Could not insert image at the current position.'), {
            title: t('Inserting image failed'),
            namespace: 'ckfinder'
        });
        return;
    }
    editor.execute('imageInsert', { source: urls });
}